import React from "react";

interface ReconnectIconProps {
  size?: number;
}

export const ReconnectIcon: React.FC<ReconnectIconProps> = ({ size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M10 13C10.4295 13.5741 10.9774 14.0491 11.6066 14.3929C12.2357 14.7367 12.9315 14.9411 13.6467 14.9923C14.3618 15.0435 15.0796 14.9403 15.7513 14.6897C16.4231 14.4392 17.0331 14.047 17.54 13.54L20.54 10.54C21.4508 9.59695 21.9548 8.33394 21.9434 7.02296C21.932 5.71198 21.4061 4.45791 20.4791 3.53087C19.5521 2.60383 18.298 2.07799 16.987 2.0666C15.676 2.0552 14.413 2.55918 13.47 3.46997L11.75 5.17997" />
    <path d="M13.9982 11C13.5688 10.4259 13.0209 9.9508 12.3917 9.60704C11.7625 9.26328 11.0667 9.05886 10.3516 9.00765C9.63645 8.95643 8.91866 9.05961 8.2469 9.3102C7.57514 9.56079 6.96513 9.95291 6.45825 10.46L3.45825 13.46C2.54746 14.403 2.04348 15.666 2.05488 16.977C2.06627 18.288 2.59211 19.542 3.51915 20.4691C4.44619 21.3961 5.70026 21.922 7.01124 21.9334C8.32222 21.9447 9.58524 21.4408 10.5282 20.53L12.2382 18.82" />
  </svg>
);
